import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

export default function createSeoConfig(description, url) {
  return {
    description,
    openGraph: {
      description,
      url,
      images: [
        {
          url: `${publicRuntimeConfig.NEXT_PUBLIC_CDN_URL}/static/images/share-cover.png`,
          width: 1200,
          height: 630,
          alt: 'TicketSwap',
        },
      ],
      type: 'website',
    },
    twitter: {
      handle: '@TicketSwap',
      site: '@TicketSwap',
      cardType: 'summary_large_image',
    },
  }
}
